import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import Student from './Component/Student'


const mapStateToProps = (state, ownProps) => ({
    studentHeader: state.student.studentHeader,
    studentList: state.student.studentList,
    totalStudent: state.student.totalStudent,
    pdfContent: state.student.pdfContent,
    currentProgram: state.organization.currentProgram,    
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap,
    classes: state.organization.classes,
    boardingTypes: state.organization.boardingTypes
})


const mapDispatchToProps = (dispatch) => ({
    fetchStudentList: payload => dispatch(Actions.fetchStudentList(payload)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    getStudentReport: (reportType, config) => dispatch(Actions.getStudentReport(reportType, config)),
    getBulkStudentReport: (reportType, config) => dispatch(Actions.getBulkStudentReport(reportType, config)),
    setLoader: () => dispatch(Actions.setLoader()),
    unsetLoader: () => dispatch(Actions.unsetLoader()),
    getStudentBoardingType: (organizationId) => dispatch(Actions.getStudentBoardingType(organizationId))
})


export default connect(mapStateToProps, mapDispatchToProps)(Student)


// WEBPACK FOOTER //
// ./src/Containers/StudentContainer/index.js